'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import moment from 'moment'
import React from 'react'

// walrus
import Text from '@components/kit/text'
import Box from '@components/kit/box'
import PollAnswerTile from './poll-answer-tile'
import Circle from '@components/kit/circle'
import { PollActivity as PollAnswer } from '@store/User/types'

/* -----------------------------------------------------------------------------
 * MedSatisfactionPollAnswer
 * -------------------------------------------------------------------------- */

export type MedSatisfactionPollAnswerProps = {
  poll: PollAnswer
}

const MedSatisfactionPollAnswer = ({
  poll
}: MedSatisfactionPollAnswerProps) => {
  const question = poll.event_data.questions[0]
  const answers = question.answers

  return (
    <Box
      width='100%'
      mt='16'
      bg='white'
      flexDirection='column'
      alignItems='center'
    >
      <Text fontSize={10} fontWeight={700} textColor='shade04'>
        {moment(poll.timestamp).format('MMM DD, YYYY')}
      </Text>

      <PollAnswerTile
        width='100%'
        mt='16'
        themeVariant='paleViolet'
        title='Medication Satisfaction'
      >
        <Text textColor='purple'>{question.question}</Text>

        <Box
          flexDirection='row'
          justifyContent='space-between'
          alignItems='center'
          mt='20'
          mb='12'
        >
          {answers.map(option => (
            <Box
              key={option[0].answer_id}
              bg={option[0].selected ? 'violet' : 'white'}
              width='48px'
              height='48px'
              borderRadius={16 as any}
              boxShadow='medium'
              justifyContent='center'
              alignItems='center'
            >
              <Text
                variant='h3'
                textColor={option[0].selected ? 'white' : 'violet'}
              >
                {option[0].label}
              </Text>
            </Box>
          ))}
        </Box>

        <Box
          flexDirection='row'
          justifyContent='center'
          alignItems='center'
          my='12'
        >
          <Circle size={8} bg='purple' />
          <Box flex='1 1 auto' bg='violet' opacity={'12%' as any} height={4} />
          <Circle size={8} bg='purple' />
        </Box>
        <Box
          flexDirection='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <Text variant='badge' textAlign='left'>
            Not Satisfied
          </Text>
          <Text variant='badge' textAlign='right'>
            Very Satisfied
          </Text>
        </Box>
      </PollAnswerTile>
    </Box>
  )
}

export default MedSatisfactionPollAnswer
